import React, { useState, useEffect } from "react";
import api from "@api";

export function useInfrastructureSelect(formValue: number) {
  const [selectedInfrastructure, setSelectedInfrastructure] = React.useState(0);
  const [infrastructures, setInfrastructures] = useState([]);
  const [isFetchinginfrastructures, setFetchingInfrastructure] = useState(
    false
  );

  useEffect(() => {
    setFetchingInfrastructure(true);
    api.infrastructure
      .getInfra()
      .then((response) => {
        let data: any = [];
        response.infrastructures.forEach((d: any) => {
          data = [
            ...data,
            {
              label: d.typeName,
              value: d.id,
            },
          ];
        });

        data = [
          {
            label: "No selection",
            value: 0,
          },
          ...data,
        ];
        setInfrastructures(data);
      })
      .catch((error) => {
        console.log(error);
      })
      .then(() => {
        setFetchingInfrastructure(false);
      });
  }, []);

  useEffect(() => {
    if (infrastructures.length !== 0) {
      if (formValue) {
        setSelectedInfrastructure(formValue);
      }
    }
    return () => {
      setSelectedInfrastructure(0);
    };
  }, [infrastructures]);

  const handleInfrastructureTypeChange = (event: any) => {
    setSelectedInfrastructure(event.target.value);
  };

  return {
    infrastructures,
    isFetchinginfrastructures,
    selectedInfrastructure,
    setSelectedInfrastructure,
    handleInfrastructureTypeChange,
  };
}
